import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

var ensureFormatSuggestionIntegrity = function ensureFormatSuggestionIntegrity(suggestions) {
  return suggestions.includes("primitive") || !suggestions.includes("comparable") ? suggestions : ["primitive"].concat(_toConsumableArray(suggestions));
};

var ensureFormatAsPrimitiveSuggestionIntegrity = function ensureFormatAsPrimitiveSuggestionIntegrity(suggestions) {
  return suggestions.includes("primitive") ? suggestions : ["primitive"].concat(_toConsumableArray(suggestions));
};

/**
 * Creates a new formatter.
 *
 * @param format Function used to format the value.
 * @param formatterOptions Additional options for the formatter.
 */
var makeFormatter = function makeFormatter(format, formatterOptions) {
  var formatter = function formatter(props) {
    var _format, _props$suggestions;

    return (_format = format(props.children, (_props$suggestions = props.suggestions) !== null && _props$suggestions !== void 0 ? _props$suggestions : [], props)) !== null && _format !== void 0 ? _format : null;
  };

  formatter.displayName = formatterOptions === null || formatterOptions === void 0 ? void 0 : formatterOptions.displayName;

  formatter.format = function (value) {
    var suggestions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var dataContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return format(value, ensureFormatSuggestionIntegrity(suggestions), dataContext);
  };

  formatter.formatAsPrimitive = function (value) {
    var suggestions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var dataContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return format(value, ensureFormatAsPrimitiveSuggestionIntegrity(suggestions), dataContext);
  };

  formatter.wrap = function (nextFormat, nextFormatterOptions) {
    var nextFormatter = makeFormatter(function (value, suggestions, dataContext) {
      var delegate = function delegate(delegatedValue, delegatedSuggestions, delegatedDataContext) {
        return formatter.format(delegatedValue, delegatedSuggestions !== null && delegatedSuggestions !== void 0 ? delegatedSuggestions : suggestions, delegatedDataContext !== null && delegatedDataContext !== void 0 ? delegatedDataContext : dataContext);
      };

      return nextFormat(delegate, value, suggestions, dataContext);
    }, nextFormatterOptions !== null && nextFormatterOptions !== void 0 ? nextFormatterOptions : formatterOptions);
    nextFormatter.innerFormatter = formatter;
    return nextFormatter;
  };

  return formatter;
};

export { makeFormatter };
